import { ReactComponent as TransferSvg } from "../../assets/images/svgs/transfer.svg";

const TransferIcon = ({ className = "", ...props }) => {
  return (
    <TransferSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TransferIcon;
